export default "__VITE_ASSET__BMCWUVyu__"